import React from "react";
import { Helmet } from "react-helmet-async";
import { orgSchema, websiteSchema } from "../lib/seo";

// Site-wide structured data (Organization + WebSite). Rendered once in App.
const GlobalSEO = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(orgSchema())}</script>
    <script type="application/ld+json">{JSON.stringify(websiteSchema())}</script>
  </Helmet>
);

export default GlobalSEO;
